import CodeStore from 'stores/CodeStore';
import TnvedCode from 'models/TnvedCode';

const NAMESPACE = 'tnved';

export default class TnvedCodeStore extends CodeStore {

  codes = this.collection({
    model: TnvedCode,
    idAttribute: 'code'
  })

  async fetchCodeData(code) {
    await super.fetchCodeData(code, NAMESPACE);
  }

  async fetchCodeDataNotes(code) {
    await super.fetchCodeDataNotes(code, NAMESPACE);
  }

  async fetchCodeDataComment(code) {
    await super.fetchCodeDataComment(code, NAMESPACE);
  }

  async fetchCodeDataClassification_comments(code) {
    await super.fetchCodeDataClassification_comments(code, NAMESPACE);
  }

  async reload() {
    await super.reload(NAMESPACE);
  }

}



// WEBPACK FOOTER //
// ./src/stores/TnvedCodeStore.js